import AppConst from "../AppConst.ts";
import Cookie from "./Cookie.js";

export default class AtsJT {

    static extractToken() {
        const base64EncodedCookieValue = Cookie.getCookieValue(AppConst.AtST);
        if (!base64EncodedCookieValue) return null;

        const decodedCookie = Cookie.base64ToUtf8(base64EncodedCookieValue);
        if (!decodedCookie) return null;

        let cookieJson;
        try {
            cookieJson = JSON.parse(decodedCookie);
        } catch (err) {
            console.error("Failed to parse cookie JSON:", err);
            return null;
        }

        return cookieJson._atst_ || null;
    }

    static extractCookieField(decodedText, key) {
        let cookieJson;
        try {
            cookieJson = JSON.parse(decodedText);
        } catch (err) {
            console.error("Failed to parse cookie JSON:", err);
            return null;
        }

        if (!cookieJson.valuesMap) {
            console.error("valuesMap not found in cookie JSON");
            return null;
        }

        const value = cookieJson.valuesMap[key];
        if (!value) {
            console.error(`Key ${key} not found in valuesMap`);
            return null;
        }

        return value;
    }

    static createValuesMap(tokenBase64) {
        return {
            [AppConst.API_AUTH_TOKEN]: tokenBase64,
        };
    }
}